var map = {
	"./contexts/context": 154,
	"./contexts/context.js": 154,
	"./contexts/diff": 155,
	"./contexts/diff.js": 155,
	"./contexts/patch": 156,
	"./contexts/patch.js": 156,
	"./contexts/reverse": 157,
	"./contexts/reverse.js": 157,
	"./date-reviver": 206,
	"./date-reviver.js": 206,
	"./diffpatcher": 294,
	"./diffpatcher.js": 294,
	"./environment": 158,
	"./environment.js": 158,
	"./filters/arrays": 295,
	"./filters/arrays.js": 295,
	"./filters/dates": 296,
	"./filters/dates.js": 296,
	"./filters/lcs": 297,
	"./filters/lcs.js": 297,
	"./filters/nested": 298,
	"./filters/nested.js": 298,
	"./filters/texts": 299,
	"./filters/texts.js": 299,
	"./filters/trivial": 300,
	"./filters/trivial.js": 300,
	"./formatters/annotated": 159,
	"./formatters/annotated.js": 159,
	"./formatters/base": 77,
	"./formatters/base.js": 77,
	"./formatters/console": 207,
	"./formatters/console.js": 207,
	"./formatters/html": 160,
	"./formatters/html.js": 160,
	"./formatters/index": 161,
	"./formatters/index.js": 161,
	"./formatters/jsonpatch": 162,
	"./formatters/jsonpatch.js": 162,
	"./main": 163,
	"./main-formatters": 437,
	"./main-formatters.js": 437,
	"./main-full": 438,
	"./main-full.js": 438,
	"./main.js": 163,
	"./pipe": 208,
	"./pipe.js": 208,
	"./processor": 301,
	"./processor.js": 301
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/src ^\.\/.*$
 ** module id = 436
 ** module chunks = 0
 **/